module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-21.412552e1.jpg";